export enum SubLineActionTypeEnum {
	Unknown = 0,
	Create = 1,
	Update = 2,
}

export default SubLineActionTypeEnum;
